<template>
  <div>
    <div class="text-right md:flex md:justify-between md:align-items-center">
      <EbHeading level="h1" class="eb-page-heading">Tableau de bord</EbHeading>
      <a :href="publicProfileUrl" class="eb-button secondary small icon-after" target="_blank" rel="noreferrer noopener" title="Voir ma fiche en ligne - Nouvelle fenêtre">Voir ma fiche en ligne <font-awesome-icon :icon="['fas', 'external-link-alt']" /></a>	
		</div>
    <div class="eb-main-cards">
      <mesDispos></mesDispos>
      <mesAccueils home></mesAccueils>
      <mesInfosParents home></mesInfosParents>
      <actualitiesReglementation></actualitiesReglementation>
    </div>
  </div>
</template>

<script>
import actualitiesReglementation from '@/components/actualitiesReglementation.vue'
import mesInfosParents from '@/components/mesInfosParents.vue'
import mesAccueils from '@/components/mesAccueils.vue'
import mesDispos from '@/components/mesDispos.vue'

export default {
  name: 'Home',
  data() {
		return {
      publicProfileUrl: ''
    }
  },
  mounted() {
		this.publicProfileUrl = this.getPublicProfileLink()
	},
  components: {
    actualitiesReglementation,
    mesInfosParents,
    mesAccueils,
    mesDispos
  }
}
</script>
